import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postSendForApproval = createApi(`SendForApprovalSlice`,"POST");

const SendForApprovalSlice = createSlice({
  name: 'SendForApprovalSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postSendForApproval.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSendForApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postSendForApproval.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SendForApprovalSlice.reducer;